import { render, staticRenderFns } from "./AddMain.vue?vue&type=template&id=63f5acf9"
import script from "./AddMain.vue?vue&type=script&lang=js"
export * from "./AddMain.vue?vue&type=script&lang=js"
import style0 from "./AddMain.vue?vue&type=style&index=0&id=63f5acf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports